import { useMemo } from "react";
import { Accordion, VoteResult } from "../../../components";
import { PollOptionDetail } from "./PollOptionDetail";
import { PollClient, PollOption, PollStats } from "../../../../types";

export function PollTable({ poll }: { poll: PollClient }) {
    const { users, options } = poll;

    const pollTable = useMemo(() => {
        const table: (PollOption & PollStats)[] = Object.keys(poll.options)
            .map(option => {
                const users = options[option].users;
                const voteCount = Object.values(users).filter(v => v).length;
                const order = 1;

                return { ...options[option], title: option, voteCount, order };
            })
            .sort((a, b) => b.voteCount - a.voteCount);

        let lastVoteCount = -1;
        for (let i = 0; i < table.length; i++) {
            if (lastVoteCount === table[i].voteCount) {
                table[i].order = table[i - 1].order;
            } else {
                table[i].order = i + 1;
            }
            lastVoteCount = table[i].voteCount;
        }

        return table;
    }, [poll.options, options]);

    const maxVoteCount = pollTable[0]?.voteCount || 0;

    return <ul className="poll-options">
        {pollTable.map(option => <li key={option.title} className={`poll-option order-${option.order}`}>
            <Accordion title={<VoteResult
                title={`${option.voteCount}x ${option.title}`}
                yes={option.voteCount}
                maybe={maxVoteCount - option.voteCount}
                no={0}
            />} >
                <PollOptionDetail users={users} option={option} />
            </Accordion>
        </li>)}
    </ul>;
}
